<script setup>
import { computed, getCurrentInstance } from 'vue'
import { shouldShowNavItem, shouldShowNavParent } from "@/utils/permissions";

const props = defineProps({
    links: {
        type: Array,
        default: null
    },
    title: {
        type: String,
        default: null
    }
})

const hoveredClass = "grey lighten-2";

function checkLinkActive(link) {
    return currentRoute.value.name === link.route.name
}

const instance = getCurrentInstance()
const currentRoute = computed(() => {
    return instance.proxy.$route
})

function linkHasChildren(link) {
    return link.children !== null && link.children !== undefined

}

function isListGroupOpen(links) {
    for (const link of links) {
        const linkMatchesCurrentRoute = link.route.name === currentRoute.value.name
        if (linkMatchesCurrentRoute) {
            return true
        }
    }
    return false
}
</script>

<template>
    <v-list nav class="background links px-2 rounded-tl rounded-bl" :style="{ minHeight: '50vh' }">
        <v-subheader v-if="title">{{ props.title }}</v-subheader>
        <template v-for="(link, index) in links">


            <template v-if="linkHasChildren(link)">

                <template v-if="shouldShowNavParent(link)">

                    <v-list-group :key="index" :prepend-icon="link.icon"
                        :value="isListGroupOpen(link.children)">


                        <template #activator>
                            <v-list-item-content>
                                <v-list-item-title class="text-body-2">{{ link.text }}</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item-group class="ml-6" :value="currentRoute.name">
                            <template v-for="childLink in link.children">
                                <v-hover v-if="shouldShowNavItem(childLink)" :key="childLink.route.name">
                                    <template #default="{ hover }">
                                        <router-link :to="childLink.route" class="text-decoration-none">
                                            <v-list-item active-class="active-list-item" :class="{
                                                'background darken-1': hover,
                                            }" :value="childLink.route.name">
                                                <v-list-item-icon>
                                                    <v-icon>{{ childLink.icon }}</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-title class="text-body-2">{{ childLink.text
                                                        }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </router-link>
                                    </template>
                                </v-hover>
                            </template>
                        </v-list-item-group>
                    </v-list-group>

                </template>

            </template>


            <v-list-item-group v-else-if="shouldShowNavItem(link)" :key="'leaf-' + index" :value="currentRoute.name">
                <v-hover>
                    <template #default="{ hover }">
                        <router-link :to="link.route" class="text-decoration-none">
                            <v-list-item active-class="active-list-item primary--text" :class="{
                                'background darken-1': hover,
                            }" :value="link.route.name">
                                <v-list-item-icon>
                                    <v-icon>{{ link.icon }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title class="text-body-2">{{ link.text }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </router-link>
                    </template>
                </v-hover>

            </v-list-item-group>
        </template>
    </v-list>
</template>

<style scoped lang="scss">
.active-list-item::before {
    background-color: var(--v-primary-base);
}
</style>
